<ng-container>
  <header class="apt-container header-lg row-2 box-shadow">
    <div class="apt-grid header-thick">
      <a routerLink="/astro-ftth" (click)="closeMenu()" class="logo">
        <img src="./assets/images/logo-maxis.svg" class="img-logo" />
      </a>
    </div>
  </header>
</ng-container>
